import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { CheckBox } from '../General/Checkbox';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import {
  CheckBoxWrapper,
  ItemTitle,
  ItemTitleWrapper,
  TitleIconWrapper,
} from './ProductFilter';
import { useState } from 'react';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { FlexRowCenterVertical, TextP } from '../../..';
import { Input } from '../../Zemplin/General/Input';

interface Props {
  type: string;
  name: string;
  data?: any;
}

function ProductFilterItem({ type, name, data }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(999);

  const changeIsOpenState = () => {
    setIsOpen(!isOpen);
  };

  const changeLimitValues = value => {
    setMinValue(value[0]);
    setMaxValue(value[1]);
  };

  return (
    <>
      <ItemTitleWrapper onClick={changeIsOpenState} isOpen={isOpen}>
        <ItemTitle>{name}</ItemTitle>
        <TitleIconWrapper>
          <TitleIcon
            icon={isOpen ? IconType.bottomArrow : IconType.topArrow}
            fill={'#414141'}
          />
        </TitleIconWrapper>
      </ItemTitleWrapper>
      {isOpen &&
        (type === 'price' ? (
          <PriceFilterDropdown>
            <Range
              min={0}
              max={2000}
              allowCross={false}
              defaultValue={[0, 999]}
              onChange={changeLimitValues}
              handleStyle={[
                {
                  backgroundColor: '#FFFFFF',
                  border: '2px solid rgba(30, 57, 141, 1)',
                },
                {
                  backgroundColor: '#FFFFFF',
                  border: '2px solid rgba(30, 57, 141, 1)',
                },
              ]}
              trackStyle={[{ backgroundColor: 'rgba(30, 57, 141, 1)' }]}
              railStyle={{ backgroundColor: 'rgba(30, 57, 141, 0.08)' }}
            />
            <InputRow>
              <PriceLimitInput type="number" value={minValue} />
              <TextP style={{ marginRight: 16, marginLeft: 16 }}>do</TextP>
              <PriceLimitInput type="number" value={maxValue} />
              <TextP style={{ marginLeft: 16 }}>€</TextP>
            </InputRow>
            <FilterDropdown>
              <CheckBoxWrapper>
                <CheckBox name={name} type={'checkbox'} selected={false} />
                <StyledLabel htmlFor={name} selected={false}>
                  {'Iba na sklade'}
                </StyledLabel>
              </CheckBoxWrapper>
              <CheckBoxWrapper>
                <CheckBox name={name} selected={true} />
                <StyledLabel htmlFor={name} selected={true}>
                  {'V akcii'}
                </StyledLabel>
              </CheckBoxWrapper>
              <CheckBoxWrapper>
                <CheckBox name={name} selected={false} />
                <StyledLabel htmlFor={name} selected={false}>
                  {'S darčekom'}
                </StyledLabel>
              </CheckBoxWrapper>
            </FilterDropdown>
          </PriceFilterDropdown>
        ) : (
          <SelectFilterDropdown>
            <CheckBoxWrapper>
              <CheckBox name={name} type={'checkbox'} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={true} />
              <StyledLabel htmlFor={name} selected={true}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox name={name} selected={false} />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
          </SelectFilterDropdown>
        ))}
    </>
  );
}

const FilterDropdown = styled.div`
  margin-top: ${rem(32)};
`;

const PriceFilterDropdown = styled(FilterDropdown)``;

const InputRow = styled(FlexRowCenterVertical)`
  margin-top: ${rem(32)};
`;

const PriceLimitInput = styled(Input)`
  box-shadow: 0 ${rem(1)} ${rem(4)} #00000014;
  border: ${rem(1)} solid #cccccc;
  border-radius: ${rem(4)};
`;

const SelectFilterDropdown = styled(FilterDropdown)`
  max-height: ${rem(165)};
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: ${rem(2)};
    border-radius: 2px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(30, 57, 141, 0.08);
  }
  ::-webkit-scrollbar-thumb {
    background: #1e398d;
  }
`;

const StyledLabel = styled.label<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  color: ${({ selected, theme }) =>
    selected ? '#1E398D' : theme.colors.textPrimary};
`;

const TitleIcon = styled(SvgIcon)`
  z-index: 100;
  position: relative;
  top: ${rem(10)};
  left: ${rem(10)};
`;

export { ProductFilterItem };
